import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'

import { referralWithdrawDialogOpenAtom } from '@root/features/referral/atoms'

import { ReferralWithdrawDrawer } from './referral-withdraw-drawer'

export const ReferralWithdrawDrawerController = () => {
  const [open, setOpen] = useAtom(referralWithdrawDialogOpenAtom)

  return (
    <AnimatePresence>
      {open ? (
        <ReferralWithdrawDrawer open={true} onOpenChange={setOpen} />
      ) : undefined}
    </AnimatePresence>
  )
}
